export interface IService {
  /** URL slug used in the route, e.g. `be-financials`. */
  slug: string
  /** Display name shown on the services list. */
  name: string
}

/**
 * Statically defined list of services available in the admin services area.
 * Add new services here as they become available.
 */
export const SERVICES: IService[] = [
  {
    slug: "be-financials",
    name: "be-financials",
  },
]
